import { useGetEcommerceOrder } from '../../../api/lending/lapiHooks';
import { useQueryParam } from '../../../hooks/useQueryParam';

export function useCurrentEcommerceOrder() {
  const orderId = useQueryParam('orderId') || undefined;

  return useGetEcommerceOrder({ orderId });
}
